<template>
	<div :class="{ 'from-order-new': isFromOrderNew }">
		<div class="search">
			<div class="block">
				<el-date-picker
					v-model="timer"
					:default-time="['00:00:00', '23:59:59']"
					value-format="timestamp"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					clearable
					style="width: 400px;"
				></el-date-picker>
			</div>
			<div class="block" style="width: 300px;">
				<el-input v-model="tinkw" placeholder="请输入发票抬头或社会统一信用代码" class="search-input"></el-input>
			</div>
			<div class="block"><el-button type="primary" @click="getData()">搜索</el-button></div>
		</div>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" height='calc(100vh - 250px)'>
			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column prop="invoice.customerName" label="发票抬头"></el-table-column>
			<el-table-column prop="invoice.tin" label="统一社会代码"></el-table-column>
			<el-table-column label="发票金额">
				<template slot-scope='scope'>
					<span class="yellow">{{scope.row.invoice.amount/100}} 元</span>
				</template>
			</el-table-column>

			<el-table-column label="申请发票时间">
				<template slot-scope='scope'>
					{{setTime(scope.row.invoice.createAt)}}
				</template>
			</el-table-column>
		  <el-table-column label="操作">
			<template slot-scope='scope'>
				<span v-if="scope.row.invoice.status == 6">
					<router-link class='blue' :to="getInvoiceDetailRoute(scope.row.invoice.id)">查看详情</router-link>
					<el-button disabled type='text'>已作废</el-button>
				</span>
				<span v-else>
						<router-link class='blue' :to="getInvoiceDetailRoute(scope.row.invoice.id)">查看详情</router-link>
						<el-button v-if="scope.row.invoice.status == 1 || scope.row.invoice.pdf != null "  type='text' @click="download(scope.row.invoice.pdf)">下载发票</el-button>
						<el-button v-else  type='text' disabled @click="download(scope.row.invoice.pdf)">下载发票</el-button>
						<el-button  type='text' @click="clickInvoice(scope.row)">作废</el-button>
				</span>
        
			</template>
		  </el-table-column>
		</el-table>
		<div class="fenye">
			<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
		</div>
	</div>
</template>

<script>
	import {invoiceList,revoke_invoice} from '@/axios/api.js'
	import common from '@/assets/common.js'
export default {
	data() {
		return {
			timer: null,
			tableData: [],
			allpage:10,
			tinkw:'',
			stateObj:['已处理','处理中','已拒绝','开票中','信息有误'],
			isFromOrderNew: false // 是否从orderNew页面跳转过来
		};
	},
	methods: {
    /**
     * 获取跳转到发票详情的路由对象
     * @param {string|number} invoiceId - 发票ID
     * @returns {Object} 路由对象
     */
    getInvoiceDetailRoute(invoiceId) {
      var route = {
        path: '/financial/invoiceDetail',
        query: { id: invoiceId }
      };
      // 如果当前页面是从orderNew跳转过来的，传递参数给详情页
      if (this.isFromOrderNew) {
        route.query.fromOrderNew = 'true';
        route.query.hideLayout = 'true';
      }
      return route;
    },
    /**
     * 作废发票
     * @param {Object} item - 发票项
     */
    clickInvoice(item) {
      console.log(item.invoice.id)
      revoke_invoice({id:item.invoice.id}).then((res)=>{
        console.log(res)
        if(res.data.code == 0) {
          this.$message.success('发票作废成功')
          // 刷新列表数据
          this.getData()
        } else {
          this.$message.error(res.msg || '发票作废失败，请稍后重试')
        }
      }).catch((err)=>{
        console.log(err)
        this.$message.error(err.msg || '发票作废失败，请稍后重试')
      })
    },
    download(pdf) {
      console.log(pdf)
      window.open(pdf);
      // window.location = 
    },
		changePage(start,count){
			this.getData(start,count)
		},
		setTime(str){
			return common.time(str)
		},
		getData(start,count) {
			var data={}
			if(this.timer){
				data={
					start:start||0,
					count:count||10,
					tinkw:this.tinkw,
					startts:this.timer[0],
					endts:this.timer[1]
				}
			}else{
				data={
					start:start||0,
					count:count||10,
					tinkw:this.tinkw
				}
			}
			invoiceList(data)
			.then(res => {
				console.log(res)
				this.tableData=res.data.obj;
				this.allpage=res.data.obj2
			})
			.catch( err => {
				console.log(err)
			})
		}
	},
	mounted(){
		// 检查是否从订单页面跳转过来
		this.isFromOrderNew = this.$route.query.fromOrderNew === 'true';
		this.getData();
    	// setTimeout(()=> {
      //   this.getData()
      // },2000)
	}
};
</script>

<style scoped="scoped">
.search {
	overflow: hidden;
	margin-top: 20px;
}

.search .block {
	float: left;
	margin-right: 10px;
}

.search-input ::v-deep .el-input__inner {
	height: 40px;
	line-height: 40px;
}

.sss {
	width: 180px;
}

/* 从orderNew页面跳转过来时添加padding */
.from-order-new {
	padding: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/invoiceList.vue